export default "__VITE_ASSET__BpF3qNbl__"